var map = {
	"./icon_attribute_cool_64.png": "11ea",
	"./icon_attribute_cute_64.png": "6d05",
	"./icon_attribute_happy_64.png": "82c2",
	"./icon_attribute_mysterious_64.png": "cadc",
	"./icon_attribute_pure_64.png": "1432"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "9a72";